<template>
  <div class="pkg-list">
    <img src="/images/goods/pkglist/pl0.jpg" alt="" />
    <img src="/images/goods/pkglist/pl1.jpg" alt="" />
    <div class="btn-g" style="background-image:url('/images/goods/pkglist/pl2.jpg')">
      <router-link to="/goods/pkg">了解更多</router-link>
      <a class="yellow" @click="buyHandler(pkgTpye.child)">立即入学¥{{ pkg[pkgTpye.child].price }}/年</a>
    </div>
    <img src="/images/goods/pkglist/pl3.jpg" alt="" />
    <img src="/images/goods/pkglist/pl4.png" alt="" />
    <div class="btn-g" style="background-image:url('/images/goods/pkglist/pl5.jpg')">
      <router-link to="/goods/parentPkg">了解更多</router-link>
      <a class="red" @click="buyHandler(pkgTpye.parent)">立即入学¥{{ pkg[pkgTpye.parent].price }}/年</a>
    </div>
    <img src="/images/goods/pkglist/pl6.jpg" alt="" />
    
    <member-guide v-model="guideShow" @confirm="confirmHReaderTips" :isMember="isPkgBought"></member-guide>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { find, isEmpty } from 'lodash'
import { dateFormat } from '@/utils/filter'
import { MemberGuide } from '@/components/goods'
// import Browser from '@/utils/browser'

const PKG_TYPE = {
  ai: 2,
  parent: 1,
  child: 0,
}
export default {
  filters: { dateFormat },
  components: { MemberGuide },
  data() {
    return {
      pkg: { 0: {}, 1: {}, 2: {} },
      pkgTpye: PKG_TYPE,
      tips: false,
      guideShow: false,
      type: 0,
    }
  },
  // async beforeRouteEnter(to, from, next) {
  //   let result = await api.payment_v1_goods_member_package_list_get({
  //     params: {
  //       channel: 1
  //     }
  //   });
  //   if (result) {
  //     if (to.query.mode === "login") {
  //       let pkgDetail = find(result, { type: parseInt(to.query.type) });
  //       if (!pkgDetail) {
  //         next();
  //         return;
  //       }
  //       if (!!pkgDetail.status) {
  //         next(vm => {
  //           vm.tips = true;
  //           vm.pkg[PKG_TYPE.parent] = find(result, { type: PKG_TYPE.parent });
  //           vm.pkg[PKG_TYPE.child] = find(result, { type: PKG_TYPE.child });
  //         });
  //         return;
  //       } else {
  //         next({
  //           path: `/goods/checkoutPkg/${pkgDetail.goodsNum}`,
  //           replace: true
  //         });
  //       }
  //     } else {
  //       next(vm => {
  //         vm.pkg[PKG_TYPE.parent] = find(result, { type: PKG_TYPE.parent });
  //         vm.pkg[PKG_TYPE.child] = find(result, { type: PKG_TYPE.child });
  //       });
  //     }
  //   }
  //   next();
  // },
  created() {
    if (isEmpty(this.pkg[PKG_TYPE.parent])) {
      this.$api
        .payment_v1_goods_member_package_list_get({
          params: {
            channel: 1,
          },
        })
        .then((e) => {
          if (e) {
            this.pkg[PKG_TYPE.parent] = find(e, { type: PKG_TYPE.parent }) || {}
            this.pkg[PKG_TYPE.child] = find(e, { type: PKG_TYPE.child }) || {}
            this.pkg[PKG_TYPE.ai] = find(e, { type: PKG_TYPE.ai }) || {}
          }
        })
    }
  },
  // watch: {
  //   tips: {
  //     immediate: true,
  //     handler: function(val) {
  //       if (val) {
  //         this.confirm(this.$route.query.type);
  //       }
  //     }
  //   }
  // },
  methods: {
    confirmHReaderTips() {
      this.guideShow = false
      this.toBuy(this.type)
    },
    buyHandler(type) {
      this.type = type
      if (this.isLogin) {
        if (!!this.pkg[type].status) {
          this.confirm(type)
        } else {
          this.toBuy(type)
        }
      } else {
        this.login(this.pkg[type].goodsNum, type)
      }
    },
    toBuy(type) {
      // if (this.isNative && Browser.isIOS() && this.getVersionControl()) {
      //   this.$store.dispatch('externalInterface/productBuy', {
      //     type: 'package',
      //     goodsNum: this.pkg[type].goodsNum,
      //   })
      // } else {
        this.$router.push(`/goods/checkoutPkg/${this.pkg[type].goodsNum}`)
      // }
    },
    // getVersionControl() {
    //   if (this.headers.deviceType === 'website') return false
    //   return this.headers.deviceDetail.indexOf('4.6.') > -1
    // },
    login(goodsNum, type) {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/navigateTo', {
          name: 'login',
          params: {
            redirect: `${process.env.VUE_APP_SHARE_URL}/goods/pkgList`,
          },
        })
      } else {
        this.$router.push({
          path: '/account/login-bySMS',
          query: {
            redirect: `/goods/pkgList`,
          },
        })
      }
    },
    confirm(type) {
      let tipsTxt = `您已开通当前课程到期时间：<br/>${dateFormat(this.pkg[type].disableDate)}<br/>是否继续续费购买？`
      this.$createDialog({
        type: 'confirm',
        icon: 'cubeic-alert',
        title: '提示',
        content: tipsTxt,
        confirmBtn: {
          text: '确认',
          active: true,
          disabled: false,
          href: 'javascript:;',
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;',
        },
        onConfirm: () => {
          this.toBuy(type)
        },
      }).show()
    },
  },
  computed: {
    ...mapGetters({
      // headers: 'auth/headers',
      isVisitor: 'auth/isVisitor',
      userInfo: 'auth/userInfo',
      isNative: 'externalInterface/isNative',
      uid: 'auth/uid',
      contextId: 'auth/contextId',
      downloadPath: 'externalInterface/downloadApp',
      isWeak: 'auth/isWeak',
      contextInfo: 'auth/contextInfo',
    }),
    isLogin() {
      return !isEmpty(this.userInfo)
    },
    isPkgBought() {
      return this.pkg[this.type].status === 1
    },
  },
}
</script>
<style scoped>
.pkg-list img {
  display: block;
  width: 100vw;
}
.btn-g {
  height: 31px;
  width: 100vw;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
.btn-g a {
  display: inline-block;
  line-height: 31px;
  color: #fff;
  background: #85b5f4;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
}
.btn-g a + a {
  margin-left: 12px;
}
.btn-g >>> .yellow {
  background: #ff9901;
}
.btn-g >>> .red {
  background: #fe6688;
}
</style>
